import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[appInit]',
  exportAs: 'init',
})
export class InitDirective {
  @Input('appInit') value: any;
}
